import { getAuth, getIdToken } from "firebase/auth";

interface HandshakeDetails {
    cipher_bits: number;
    cipher_list: string[];
    cipher_use: string;
    cipher_version: string;
    protocol: string;
}

interface CertificateBase {
  domain: string;
  issuer: string | null;
  serial_number: string | null;
  issued_at: string | null;
  subject: string | null;
  expires_at: string | null;
}

interface RootCertificate extends CertificateBase {
  is_self_signed?: boolean | null;
  signature_algorithm?: string | null;
}

interface IntermediateCertificate extends CertificateBase {
   signature_algorithm?: string | null;
}


interface CertificateResponse {
  id?: string;
  name: string;
  serial_number: string;
  domain: string;
  days_remaining: number;
  expired: boolean;
  issuer: string;
  subject: string;
  intermediate_cert?: [IntermediateCertificate] | null;
  root_cert?: RootCertificate | null;
  subject_alternative_names: string[];
  issued_at: string;
  expires_at: string;
  public_key?: string;
  chain_length: string,
  last_checked: string,
  signature_algorithm: string,
  key_type: string,
  handshake_details: HandshakeDetails;
  added_by: string;
  date_added: string;
  expiry_date: string;
  status: string;
  version: number;
  pem: string;
}

interface CertificateData  extends CertificateResponse {
  domain: string;
  issued_at: string;
  expires_at: string;
  issuer: string;
  serial_number: string;
  subject_alternative_names: string[];
  days_remaining: number;
  expired: boolean;
}

const checkCertificateExpiration = async (domain: string, serial_number?: string): Promise<CertificateData> => {
  try {
    const auth = getAuth();
    const user = auth.currentUser;
    if (!user) {
      throw new Error("User not authenticated");
    }
    // const url = "http://localhost:8080/get_cert";
    const url = "https://remindme-planet.appspot.com/get_cert";
    const reqUrl = (serial_number === undefined) ? `${url}` : `${url}/${serial_number}`;
    
    const token = await getIdToken(user);
    // console.log(token)
    const response = await fetch(reqUrl, {
      method: "POST",
      headers: {
        'Authorization': `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ domain: domain, uid: user.uid }),
    });

    if (!response.ok) {
      throw new Error("Failed to fetch certificate details");
    }

    const data: CertificateResponse = await response.json();

    return data
  } catch (error) {
    console.error("Error fetching certificate details:", error);
    throw new Error(`Failed to check certificate: Failed to check certificate for ${domain}`);
  }
};


export default checkCertificateExpiration;
export type { CertificateResponse, RootCertificate, IntermediateCertificate };
